var map = {
	"./1piechart.png": 137,
	"./2piechart.png": 138,
	"./3piechart.png": 139,
	"./Asset 1.png": 103,
	"./Asset 10.png": 104,
	"./Asset 11.png": 105,
	"./Asset 12.png": 106,
	"./Asset 13.png": 107,
	"./Asset 14.png": 108,
	"./Asset 15.png": 109,
	"./Asset 16.png": 110,
	"./Asset 17.png": 111,
	"./Asset 18.png": 112,
	"./Asset 19.png": 113,
	"./Asset 2.png": 114,
	"./Asset 20.png": 115,
	"./Asset 21.png": 116,
	"./Asset 22.png": 117,
	"./Asset 23.png": 118,
	"./Asset 24.png": 119,
	"./Asset 25.png": 120,
	"./Asset 26.png": 121,
	"./Asset 27.png": 122,
	"./Asset 28.png": 123,
	"./Asset 29.png": 124,
	"./Asset 3.png": 125,
	"./Asset 30.png": 126,
	"./Asset 4.png": 127,
	"./Asset 5.png": 128,
	"./Asset 8.png": 129,
	"./Asset 9.png": 130,
	"./p1.png": 481,
	"./p2.png": 482,
	"./p3.png": 483,
	"./p4.png": 484,
	"./p5.png": 485,
	"./p6.png": 486,
	"./p7.png": 487,
	"./p8.png": 488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;